import React, { useEffect, useRef, useState } from 'react'
import kingdomImg from '../../assets/logo_kingdom_256px.png';
import ReCAPTCHA from "react-google-recaptcha";
import MsgUtils from '../Tools/MsgUtils';
import ConsultasComunes from '../Sql/ConsultasComunes';
const server = process.env.REACT_APP_SERVER;

function AutorizarEncuestaGeneral() {
    const [regGenerado,setRegGenerado] = useState('');
    const [carnet,setCarnet] = useState();
    const [regional,setRegional] = useState('');
    const [validoCaptcha,setValidoCaptcha] = useState(false);
    const [idEncuesta,setIdEncuesta] = useState(null);
    const captchat = useRef(null);
    const onChange = () => {
        if (captchat.current.getValue()) {
            setValidoCaptcha(true);
        }
    }
    const validarDatos=async()=>{
        if(validoCaptcha==true){
            if(regGenerado==regional){
                try {
                    var result = await ConsultasComunes.validarColaboradorEncuesta({regional,carnet,'ID_ENCUESTA':idEncuesta});
                    if(result.ok){
                        window.location.replace(`${server}/Encuesta/${result.ok}`);
                    }else{
                        MsgUtils.msgError(result.error);
                    }
                } catch (error) {
                    MsgUtils.msgError(error.message);
                }
            }else{
                MsgUtils.msgError("Regional Incorrecta para este Formulario")
            }
        }else{
            MsgUtils.msgError("Resuelva el captchat")
        }
    }
    useEffect(() => {
        var dato = window.location.pathname.split('/');
        if(dato.length==4){
            setIdEncuesta(parseInt(dato[2]))
            setRegGenerado(dato[3])
        }
    }, [])
    return (
        <div className="container-fluid " >
            <div className="d-flex justify-content-center align-items-center py-4" >
                <div className="card px-4 py-2 bg-dark bg-gradient text-white" id="form1">
                    <div className="form-data" v-if="!submitted">
                        <div className="forms-inputs mb-4 text-center">
                            <div className='text-light fw-bold'>Validar Evaluacion/Encuesta</div>
                            <div className="position-relative align-items-center">
                                <img src={kingdomImg} width="95" className="align-items-center" />
                            </div>
                        </div>
                        <div className="forms-inputs mb-4">
                            <span>Carnet Identidad</span>
                            <input type="text"
                                className="form-control text-center ds-input"
                                placeholder="CI"
                                autoFocus
                                onChange={(e) => setCarnet(e.target.value)}
                                value={carnet}
                            />
                        </div>
                        <div className="forms-inputs mb-2">
                            <span>Regional</span>
                            <select className="form-select btn-sm btn-light text-center " onChange={(e) => setRegional(e.target.value)}>
                                <option value=''> NINGUNO</option>
                                <option value="990">Cochabamba</option>
                                <option value="991">Santa Cruz</option>
                            </select>
                        </div>
                        <div className="forms-inputs mb-4 mx-auto text-center ">
                            <ReCAPTCHA
                                ref={captchat}
                                className="g-recaptcha"
                                theme="dark"
                                sitekey="6LcktxUgAAAAAI7TXwwBes8u9bz79PnCsweM6IL0"
                                onChange={onChange}
                            />
                            {validoCaptcha === false && <div className="badge bg-danger text-wrap">
                                Valida el captchat antes de entrar
                            </div>}
                        </div>
                        <div className="forms-inputs mb-4 text-center">
                            <button className='btn btn-secondary bg-gradient'
                                title='Ingresar al formulario'
                                onClick={()=>validarDatos()}>
                                <i className="fa-solid fa-user-tie"></i>
                                <span className="px-1">Entrar</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AutorizarEncuestaGeneral